import Cookies from "js-cookie";
import { ComponentType, FunctionComponent, useEffect } from "react";
import { supabase } from "./initSupabase";
import {
  AuthContextProvider,
  Auth,
  useAuth,
  DjinnComponentsProvider,
} from "djinn-components";
import authenticationService from "./auth.service";
import LoadingComponent from "../components/LoadingComponent";
import AuthLayout from "../components/Layouts/AuthLayout";

const Container = (props: any) => {
  const { user, getUser, authReloading } = useAuth();

  useEffect(() => {
    try {
      getUser();

      const { data: authListener } = supabase.auth.onAuthStateChange(
        async (event, session) => {
          if (event !== "TOKEN_REFRESHED") {
            getUser();
          }

          if (session?.user.id) {
            Cookies.set("appsicle-logged-in-user", session?.user.id, {
              domain: process.env.REACT_APP_COOKIE_DOMAIN,
            });
          } else {
            Cookies.remove("appsicle-logged-in-user", {
              domain: process.env.REACT_APP_COOKIE_DOMAIN,
            });
          }
        }
      );

      return () => {
        authListener?.subscription.unsubscribe();
      };
    } catch (error) {
      if (process.env.NODE_ENV === "development") {
        console.log(error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (authReloading && !user) return <LoadingComponent />;

  if (user) return props.component;
  return props.children;
};

export function withSupaBaseAuth<T extends object>(
  Component: ComponentType<T>
) {
  const AppWithAuthenticator: FunctionComponent<T> = (props) => {
    return (
      <DjinnComponentsProvider>
        <AuthContextProvider
          registrationEnabled={true}
          authenticationService={authenticationService}
          authenticationServiceConfig={{
            socialProviders: [],
            termsUrl: "https://djinnapps.com/privacy-policy",
            supportUrl: "https://support.djinnapps.com/appsicle",
            logoUrl: "/",
            logo: "/logo-full.svg",
            sidebarItems: [
              {
                title: "Get setup in minutes",
                message:
                  "Get a fully fledged SEO optimised site to compliment your app.",
              },
            ],
            registerTermsText: (
              <div className="mt-2 text-sm text-gray-450 p-1">
                By signing up to Appsicle you agree to our{" "}
                {/* <a
                  className="font-bold"
                  href="https://appsicle.co/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>{" "}
                and our{" "} */}
                <a
                  className="font-bold"
                  href="https://djinnapps.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </div>
            ),
          }}
        >
          <Container {...props} component={<Component {...props} />}>
            <AuthLayout>
              <Auth magicLink />
            </AuthLayout>
          </Container>
        </AuthContextProvider>
      </DjinnComponentsProvider>
    );
  };
  return AppWithAuthenticator;
}
